module.exports = "<address-form form-controller=\"$ctrl.shippingAddressForm\" model=\"$ctrl.model\" auto-complete-prefix=\"section-shipping shipping\" should-verify-address=\"$ctrl.useAddressVerification\" verified-message=\"'Your address has been verified for shipping accuracy'\"></address-form> <md-checkbox ng-model=\"$ctrl.model.shippingAsBilling\" aria-label=\"Use as billing address\" ng-if=\"!$ctrl.hideShippingAsBilling\"> Use as billing address </md-checkbox> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/shippingAddressForm/shippingAddressForm.html
// module id = 807
// module chunks = 0